export const ORG_REQUEST = "ORG_REQUEST";
export const ORG_SUCCESS = "ORG_SUCCESS";
export const ORG_FAIL = "ORG_FAIL";
export const ORG_CLEAR_ERRORS = "ORG_CLEAR_ERRORS";

export const ORG_SIMPLE_REQUEST = "ORG_SIMPLE_REQUEST";
export const ORG_SIMPLE_SUCCESS = "ORG_SIMPLE_SUCCESS";
export const ORG_SIMPLE_FAIL = "ORG_SIMPLE_FAIL";
export const ORG_SIMPLE_CLEAR_ERRORS = "ORG_SIMPLE_CLEAR_ERRORS";
